import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild, ChangeDetectorRef, NgZone, ChangeDetectionStrategy } from '@angular/core';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';

@Component({
  selector: 'app-cropped-image',
  templateUrl: './cropped-image.component.html',
  styleUrl: './cropped-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CroppedImageComponent implements AfterViewInit, OnChanges, OnDestroy {

  constructor(
    private sharedService: SharedService,
    public commonService: CommonService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private local: LocalServiceService
  ) { }

  public isOnBrowserNow: boolean = false;

  private resizeObserver: ResizeObserver | null = null;

  @ViewChild('imageContainer')
  public imageContainer: ElementRef;

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    this.local.clearTimeout(this.timeout1)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cropInformation'] && this.sharedService.isBrowser()) {
      if (this.imageContainer) {
        this._loadImage();
      }
    }
  }

  private imageErrorHandler() {
    this.backgroundPositionX = '0px';
    this.backgroundPositionY = '0px';
    this.backgroundHeight = '100%';
    this.backgroundWidth = '100%';
  }

  public showImageSrc = 'url(../../../assets/images/shop/default.png)';
  private _isImageLoadCalled = false;
  private _imageLoaded = false;
  private _loadImage() {
    ///make sure crop is process after image is loaded to not show distorted default image
    try {
      if (this._isImageLoadCalled) { //no duplicate call

        this._processCropInfo();
        return;
      }
      this._isImageLoadCalled = true;


      const imgUrl = `url(' ${this.imgSrc} ')`;
      const image = new Image()
      image.onload = () => {
        this.showImageSrc = imgUrl;
        this._imageLoaded = true;
        this._processCropInfo();
        this.cdr.detectChanges()
      }
      image.src = this.imgSrc;
    } catch (e) {
      console.error(e)
    }


  }
  private _processCropInfo() {

    try {
      if (!this._imageLoaded) {
        return;
      }

      if (!this.cropInformation || this.cropInformation == 'null') {
        // console.warn('no crop information given')
        return;
      }

      const { isYAxisTheOneThatIsLocked, offsetRatio, imageAspectRatio, rotationInDegrees } = (typeof this.cropInformation == 'string') ?
        JSON.parse(this.cropInformation) : this.cropInformation;
      if ([isYAxisTheOneThatIsLocked, offsetRatio, imageAspectRatio].includes(null)) {
        console.error("parse info is wrong!", this.cropInformation);
        return;
      }
      const containerWidth = this.imageContainer.nativeElement.clientWidth;
      const containerHeight = this.imageContainer.nativeElement.clientHeight;

      if (isYAxisTheOneThatIsLocked) {
        this.backgroundHeight = containerHeight + 'px';
        const backgroundWidth = Math.ceil(containerHeight * imageAspectRatio)
        this.backgroundWidth = backgroundWidth + 'px'
        this.backgroundPositionX = Math.ceil(offsetRatio * -1 * (backgroundWidth)) + 'px';
        this.backgroundPositionY = '0px';
      } else {
        this.backgroundWidth = containerWidth + 'px';
        const backgroundHeight = Math.ceil(containerWidth * 1 / imageAspectRatio)
        this.backgroundHeight = backgroundHeight + 'px'
        this.backgroundPositionY = Math.ceil(offsetRatio * -1 * (backgroundHeight)) + 'px';
        this.backgroundPositionX = '0px';
      }

      this.rotationInDegrees = rotationInDegrees ?? 0;

    } catch (e) {
      this._checkForImageErrors();
    } finally {
      this.cdr.detectChanges();
    }
  }

  private _checkForImageErrors() {
    const testImg = new Image();
    testImg.src = this.imgSrc;
    testImg.onerror = () => {
      this.imageErrorHandler();
    }
  }

  timeout1: any;
  ngAfterViewInit(): void {
    if (this.sharedService.isBrowser()) {
      // Avoid ExpressionChangedAfterItHasBeenCheckedError by running in ngZone and marking for check
      this.ngZone.runOutsideAngular(() => {
        this.local.clearTimeout(this.timeout1)
        this.timeout1 = setTimeout(() => {
          this.ngZone.run(() => {
            this.isOnBrowserNow = true;
            this.cdr.detectChanges();
            this.resizeObserver?.disconnect();
            this._loadImage();
            this.resizeObserver = new ResizeObserver(() => {
              this._loadImage();
            });
            if (this.imageContainer && this.imageContainer.nativeElement) {
              this.resizeObserver.observe(this.imageContainer.nativeElement);
            }
          });
        });
      });
    }
  }

  @Input({ required: true })
  public imgSrc: string = '';

  @Input({ required: true })
  public cropInformation: string;

  @Input()
  public imgAlt = ''

  @Input()
  public imgClass = '';

  @Input()
  public isReported = false;

  public backgroundPositionX = '0px';
  public backgroundPositionY = '0px';

  public backgroundWidth = '100%';
  public backgroundHeight = '100%';

  public rotationInDegrees: number = 0;
}
